import script from "./ExportBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportBtn.vue?vue&type=script&lang=ts&setup=true"

import "./ExportBtn.vue?vue&type=style&index=0&id=bf08c074&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf08c074"]])

export default __exports__